var _rect, _circle, _path, _path2, _rect2, _rect3, _rect4, _path3, _path4, _path5, _rect5, _rect6, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransactionHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 17,
    fill: "#FCE6EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 4.5C2 3.11929 3.11929 2 4.5 2H27C28.6569 2 30 3.34315 30 5V36H29.1482C28.8689 36 28.5911 35.961 28.3226 35.8842L26.5313 35.3715C26.0244 35.2264 25.4883 35.2174 24.9769 35.3455L23.2126 35.7874C22.6582 35.9262 22.0756 35.9038 21.5335 35.7228L20.7684 35.4673C20.1517 35.2614 19.4847 35.2614 18.868 35.4673L18.2229 35.6827C17.6062 35.8886 16.9393 35.8886 16.3225 35.6827L15.6775 35.4673C15.0607 35.2614 14.3938 35.2614 13.7771 35.4673L13.132 35.6827C12.5153 35.8886 11.8483 35.8886 11.2316 35.6827L10.5226 35.4459C9.94545 35.2532 9.32334 35.2405 8.73882 35.4096L7 35.9126V9.5C7 8.11929 5.88071 7 4.5 7C3.11929 7 2 5.88071 2 4.5Z",
    fill: "#4DAADD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 10V4.66667C7 3.22215 6.1684 2 4.49712 2C3.21062 2 2 3.16809 2 4.61261L2 7.06026C2 9.11111 1.99021 10 3.80879 10C4.57116 10 5.24739 10 7 10Z",
    fill: "#276CA4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 21.6665,
    width: 13.3333,
    height: 1.66667,
    rx: 0.833333,
    fill: "#99DDF3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 25,
    width: 13.3333,
    height: 1.66667,
    rx: 0.833333,
    fill: "#99DDF3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 28.3335,
    width: 8.33333,
    height: 1.66667,
    rx: 0.833333,
    fill: "#99DDF3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5307 17.8626C17.6019 17.8161 16.7071 17.5883 15.8462 17.1792V14.864C16.3382 15.1383 16.8725 15.3684 17.4493 15.5544C18.026 15.7357 18.5328 15.8264 18.9696 15.8264C19.3301 15.8264 19.593 15.7799 19.7584 15.6869C19.9281 15.5893 20.0129 15.4289 20.0129 15.2057C20.0129 15.0523 19.9514 14.9221 19.8284 14.8152C19.7097 14.7083 19.5082 14.5874 19.2241 14.4526C18.9442 14.3178 18.5646 14.155 18.0854 13.9644C17.5468 13.7459 17.1121 13.5019 16.7813 13.2322C16.4505 12.9579 16.2088 12.6534 16.0561 12.3187C15.9077 11.9793 15.8335 11.5586 15.8335 11.0565C15.8335 10.2894 16.0583 9.68968 16.5078 9.25732C16.9573 8.82497 17.6316 8.55765 18.5307 8.45537V7.5H19.8475V8.44142C20.6914 8.49256 21.5417 8.72036 22.3984 9.12483L21.6414 11.1123C20.755 10.6753 19.9556 10.4568 19.2432 10.4568C18.9039 10.4568 18.6643 10.5033 18.5243 10.5962C18.3886 10.6846 18.3208 10.8171 18.3208 10.9937C18.3208 11.1471 18.3695 11.275 18.4671 11.3773C18.5689 11.4749 18.7427 11.5865 18.9887 11.712C19.2347 11.8329 19.5761 11.9747 20.0129 12.1374C20.8992 12.4814 21.5354 12.8742 21.9213 13.3159C22.3072 13.7529 22.5002 14.3178 22.5002 15.0105C22.5002 15.7915 22.2733 16.4261 21.8195 16.9142C21.37 17.4024 20.7126 17.7046 19.8475 17.8208V19.1667H18.5307V17.8626Z",
    fill: "#99DDF3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9998 35.8333C26.3179 35.8333 23.3332 32.8486 23.3332 29.1667C23.3332 25.4848 26.3179 22.5 29.9998 22.5C33.6817 22.5 36.6665 25.4848 36.6665 29.1667C36.6665 32.8486 33.6817 35.8333 29.9998 35.8333Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9998 35.8333C26.3179 35.8333 23.3332 32.8486 23.3332 29.1667C23.3332 25.4848 26.3179 22.5 29.9998 22.5C33.6817 22.5 36.6665 25.4848 36.6665 29.1667C36.6665 32.8486 33.6817 35.8333 29.9998 35.8333Z",
    stroke: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 29.1665,
    y: 29.1665,
    width: 5,
    height: 1.66667,
    rx: 0.833333,
    fill: "#E57200"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 30.8335,
    y: 24.1665,
    width: 6.66667,
    height: 1.66667,
    rx: 0.833333,
    transform: "rotate(90 30.8335 24.1665)",
    fill: "#E57200"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0007 37.5002C25.3983 37.5002 21.6673 33.7692 21.6673 29.1668C21.6673 28.1866 21.8366 27.2459 22.1474 26.3724C22.3124 25.9087 22.8637 25.7446 23.2874 25.9951C23.6591 26.2148 23.7986 26.6787 23.6642 27.089C23.4499 27.7429 23.334 28.4413 23.334 29.1668C23.334 32.8487 26.3188 35.8335 30.0007 35.8335C33.6825 35.8335 36.6673 32.8487 36.6673 29.1668C36.6673 25.7666 34.1217 22.9609 30.8323 22.5515C30.3756 22.4947 30.0007 22.1271 30.0007 21.6668C30.0007 21.2066 30.3748 20.8291 30.8328 20.8745C35.0445 21.2921 38.334 24.8453 38.334 29.1668C38.334 33.7692 34.603 37.5002 30.0007 37.5002Z",
    fill: "#E57200"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4998 25.0032C22.2581 24.9821 22.0092 25.0653 21.8242 25.2528L19.4159 27.6935C19.0834 28.0305 19.0834 28.5769 19.4159 28.9139C19.7484 29.2509 20.2875 29.2509 20.6201 28.9139L22.4998 27.0088L24.3796 28.9139C24.7121 29.2509 25.2512 29.2509 25.5838 28.9139C25.9163 28.5769 25.9163 28.0305 25.5838 27.6935L23.1754 25.2528C22.9904 25.0653 22.7415 24.9821 22.4998 25.0032Z",
    fill: "#E57200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionHistory);
export default __webpack_public_path__ + "static/media/TransactionHistory.1e3ddc71c50b8f6a88876741fdb4d949.svg";
export { ForwardRef as ReactComponent };